import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from '../cx';
/**
 * 基础文本输入框(`type` 由调用方指定:text/password/email/...,默认浏览器 text)。
 * 只负责控件本身;label/hint/error 布局请配合 `FormField` 使用。
 * `invalid` prop 与外部注入的 `aria-invalid` 合并为同一个属性,不会互相覆盖。
 */
export function Input({ invalid = false, className, ref, ...rest }) {
    const { 'aria-invalid': ariaInvalidProp, ...inputRest } = rest;
    const effectiveInvalid = invalid || ariaInvalidProp === true || ariaInvalidProp === 'true';
    return (_jsx("input", { ...inputRest, ref: ref, "aria-invalid": effectiveInvalid || undefined, className: cx('wv-input', className) }));
}
